import { useState } from "react";
import { GetSpreadSheetID } from "../Config";
import { Button, Modal, Form } from "react-bootstrap";
import { Question, constructQuestion } from "../Questions";

type Props = {
  setQuestions: Function;
  setTime: Function;
};

export function FetchQuestionModal({ setQuestions, setTime }: Props) {
  const [show, setShow] = useState(false);
  const [sheetURL, setSheetURL] = useState("");
  const [sheetName, setSheetName] = useState("");
  const [isFetchingQuestion, setIsFetchingQuestion] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  function handleSheetURLChange(e: React.ChangeEvent<HTMLInputElement>) {
    setSheetURL(e.target.value);
  }

  function handleSheetNameChange(e: React.ChangeEvent<HTMLInputElement>) {
    setSheetName(e.target.value);
  }

  async function handleSetQuestion(sheetURL: string) {
    setIsFetchingQuestion(true);
    try {
      const sheetID = GetSpreadSheetID(sheetURL);
      const response = await fetch(
        `https://sheets.googleapis.com/v4/spreadsheets/${sheetID}/values/${sheetName}?key=${process.env.REACT_APP_GOOGLE_SHEETS_API_KEY}`,
      );
      const json = await response.json();
      console.log(json);
      const datas = json.values;
      //1行目をスキップして読み込む
      const gotquestions: Array<Question> = datas.filter(
        (ekement:any,index:any) =>{return index !== 0}
      ).map(
        (element: any, index: any) => {
          return constructQuestion(index + 1, element);
        },
      );
      console.log(gotquestions);
      setQuestions(gotquestions);
      console.log("問題を取得しました");
      handleClose();
    } catch (error) {
      alert("問題を取得できませんでした");
      console.error(error);
    }
    setIsFetchingQuestion(false);
  }

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        Open Settings
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>問題読み込み設定</Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>シートの共有URL</Form.Label>
              <Form.Control value={sheetURL} onChange={handleSheetURLChange} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>読み込むシートの名前</Form.Label>
              <Form.Control
                value={sheetName}
                onChange={handleSheetNameChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              handleSetQuestion(sheetURL);
              setTime(0);
            }}
            disabled={isFetchingQuestion}
          >
            {isFetchingQuestion ? "問題を取得しています..." : "問題を取得する"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
